import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { ServicesTI } from '../components/ServicesTI';
import { Telephonie } from '../components/Telephonie';
import { InfrastructureFibreOptique } from '../components/InfrastructureFibreOptique';
import { PartenairesSection } from '../components/PartenairesSection';
import { ProduitsUbiquiti } from '../components/ProduitsUbiquiti';
import { LogicielsSurMesure } from '../components/LogicielsSurMesure';
import { LogicielsDeploiement } from '../components/LogicielsDeploiement';
import { ProduitsInnova } from '../components/ProduitsInnova';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
import { AnnouncementModal } from '../components/AnnouncementModal';
import { Toaster } from '../components/ui/sonner';
import { usePageTracking } from '../hooks/usePageTracking';

export const HomePage = () => {
  usePageTracking();
  
  return (
    <div className="min-h-screen bg-[#050505]">
      <Header />
      <main>
        <Hero />
        <ServicesTI />
        <Telephonie />
        <InfrastructureFibreOptique />
        <PartenairesSection />
        <ProduitsUbiquiti />
        <LogicielsSurMesure />
        <LogicielsDeploiement />
        <ProduitsInnova />
        <Contact />
      </main>
      <Footer />
      <AnnouncementModal />
      <Toaster />
    </div>
  );
};
